export const LOCKED_CONTENT_TEXT = "Contact your Admin for future access";
